{
  "legal": {
    "privacy": {
      "title": "隐私政策",
      "effectiveDate": "生效日期：2026 年 1 月 1 日",
      "intro": "nextsub（“我们”）运营 nextsub 控制面板软件及相关网站。本隐私政策说明我们在您使用服务时如何收集、使用和保护相关信息。",
      "sections": [
        {
          "title": "1. 我们收集的信息",
          "paragraphs": [
            "您创建账户时直接提供的信息会被收集，包括邮箱地址和密码哈希。我们还会收集服务产生的用量数据，包括代理节点流量报告、心跳遥测、订阅用量记录和管理员操作日志。",
            "访问本网站时，我们可能通过 Cloudflare 边缘网络自动收集技术信息，例如 IP 地址、浏览器类型、来源页面和访问页面。"
          ]
        },
        {
          "title": "2. 我们如何使用这些信息",
          "paragraphs": ["我们使用所收集的信息用于："],
          "items": [
            "验证用户身份并维持安全会话",
            "提供并运营 nextsub 控制面板",
            "生成用量计量和账单记录",
            "检测并防止滥用或未经授权的访问",
            "改进服务并诊断技术问题"
          ]
        },
        {
          "title": "3. 数据共享",
          "paragraphs": ["我们不会出售您的个人数据。我们可能与以下对象共享数据："],
          "entries": [
            {
              "lead": "Cloudflare",
              "body": "用于边缘分发、DDoS 防护和 Turnstile 机器人检测"
            },
            {
              "lead": "服务提供商",
              "body": "承担保密义务的基础设施和托管合作伙伴"
            },
            {
              "lead": "执法机关",
              "body": "在适用法律要求时，或为保护权利与安全所必需时"
            }
          ]
        },
        {
          "title": "4. Cookie 与分析",
          "paragraphs": [
            "我们使用浏览器本地存储来保存身份验证刷新令牌。我们不使用第三方广告 Cookie。Cloudflare 可能出于安全和性能目的，在其边缘网络运行过程中设置 Cookie。"
          ]
        },
        {
          "title": "5. 数据保留",
          "paragraphs": [
            "账户数据在账户存续期间保留。用量和计量记录最多保留 24 个月，用于计费和审计。您可以随时联系我们，请求删除账户及相关个人数据。"
          ]
        },
        {
          "title": "6. 您的权利",
          "paragraphs": [
            "视您所在司法管辖区而定，您可能有权访问、更正或删除个人数据，限制或反对处理，以及进行数据可携。行使上述权利请通过下方方式联系我们。"
          ]
        },
        {
          "title": "7. 安全",
          "paragraphs": [
            "我们采用行业标准安全措施，包括传输层 TLS 加密、bcrypt 密码哈希、短时 JWT 访问令牌以及 Cloudflare WAF 防护。任何传输或存储方式都无法做到 100% 安全，我们不能保证绝对安全。"
          ]
        },
        {
          "title": "8. 政策变更",
          "paragraphs": [
            "我们可能不时更新本政策。重大变更将通过在本页发布新政策并更新生效日期的方式通知用户。"
          ]
        },
        {
          "title": "9. 联系方式",
          "paragraphs": ["隐私相关咨询，请与销售代表取得联系。"]
        }
      ]
    },
    "terms": {
      "title": "服务条款",
      "effectiveDate": "生效日期：2026 年 1 月 1 日",
      "intro": "访问或使用 nextsub 控制面板（“服务”）即表示您同意受本服务条款（“条款”）约束。如不同意本条款，请勿使用本服务。",
      "sections": [
        {
          "title": "1. 条款接受",
          "paragraphs": [
            "本条款构成您（“用户”）与 nextsub（“公司”）之间具有法律约束力的协议。本条款适用于服务的所有用户，包括运营商、租户管理员和最终用户。"
          ]
        },
        {
          "title": "2. 服务说明",
          "paragraphs": [
            "nextsub 是一套多租户代理管理控制面板，供运营商开通并管理代理节点、租户、订阅、凭证和用量计量。本服务以软件及托管控制面板的形式提供，可通过网页界面和 REST API 访问。"
          ]
        },
        {
          "title": "3. 可接受使用",
          "paragraphs": ["您同意不得将本服务用于："],
          "items": [
            "协助非法活动或违反适用法律",
            "分发恶意软件、实施钓鱼或从事欺诈",
            "干扰或破坏本服务或其基础设施",
            "试图未经授权访问账户或系统",
            "违反法律规避地域限制或制裁",
            "未经事先书面同意转售或再许可本服务"
          ],
          "closing": "公司有权暂停或终止违反本政策的账户。"
        },
        {
          "title": "4. 账户责任",
          "paragraphs": [
            "您有责任对凭证保密，并对账户下发生的所有活动负责。如发现未经授权使用账户，必须立即通知我们。因您未能妥善保管凭证而导致的未经授权访问所造成的损失，公司不承担责任。"
          ]
        },
        {
          "title": "5. 付款与计费",
          "paragraphs": [
            "付费套餐按月或按年预付。除法律要求或另有书面约定外，费用不予退还。未能付款可能导致服务被暂停。公司保留在提前 30 天通知后调整价格的权利。"
          ]
        },
        {
          "title": "6. 知识产权",
          "paragraphs": [
            "本服务及其底层软件、文档和商标归公司所有。您获得有限的、非独占、不可转让的许可，仅可按本条款使用本服务。您通过本服务上传或生成的数据仍归您所有。"
          ]
        },
        {
          "title": "7. 责任限制",
          "paragraphs": [
            "在法律允许的最大范围内，公司不对因使用或无法使用本服务而产生的任何间接、附带、特殊、后果性或惩罚性损害承担责任，包括利润、数据或商誉损失，即使公司已被告知可能发生此类损害。公司的累计责任总额不超过您在索赔发生前 12 个月内已支付的费用。"
          ]
        },
        {
          "title": "8. 免责声明",
          "paragraphs": [
            "本服务按“现状”和“现有”提供，不提供任何明示或默示保证，包括适销性、特定用途适用性和不侵权保证。公司不保证服务不中断、无错误或不含有害组件。"
          ]
        },
        {
          "title": "9. 终止",
          "paragraphs": [
            "任何一方可随时终止本协议。如违反本条款或未付款，公司可立即暂停或终止您的访问。终止后，您使用本服务的权利即告停止，公司可在宽限期后删除您的数据。"
          ]
        },
        {
          "title": "10. 适用法律",
          "paragraphs": [
            "本条款受适用法律管辖，不考虑法律冲突原则。任何争议应通过有约束力的仲裁，或在书面约定的有管辖权法院解决。"
          ]
        },
        {
          "title": "11. 条款变更",
          "paragraphs": [
            "我们可能不时更新本条款。变更生效后继续使用本服务，即视为接受修订后的条款。重大变更将通过电子邮件或应用内通知至少提前 14 天告知。"
          ]
        },
        {
          "title": "12. 联系方式",
          "paragraphs": ["有关本条款的问题，请与销售代表取得联系。"]
        }
      ]
    }
  },
  "audit": {
    "actions": {
      "auth": {
        "login": "用户登录",
        "refresh": "续期登录状态",
        "logout": "退出登录"
      },
      "user": {
        "create": "创建用户",
        "update": "更新用户",
        "delete": "删除用户",
        "enable": "启用用户",
        "disable": "停用用户",
        "disabled": "用户已停用",
        "test": "测试用户",
        "promote_to_tenant": "将用户设为租户",
        "manager": {
          "update": "调整用户负责人"
        },
        "role": {
          "grant": "授予租户管理员角色",
          "revoke": "撤销租户管理员角色"
        },
        "profile": {
          "update": "个人资料已更新"
        }
      },
      "tenant": {
        "create": "创建租户",
        "update": "更新租户",
        "delete": "删除租户",
        "disabled": "停用租户",
        "onboard": "完成租户开通"
      },
      "external_subscription": {
        "create": "创建外部订阅",
        "update": "更新外部订阅",
        "delete": "删除外部订阅",
        "sync": "同步外部订阅"
      },
      "billing": {
        "subscription": {
          "created": "创建计费订阅",
          "activated": "激活计费订阅",
          "cancelled": "取消计费订阅",
          "expired": "计费订阅已到期",
          "paused": "暂停计费订阅",
          "resumed": "恢复计费订阅",
          "replaced": "替换计费订阅",
          "traffic_reset": "重置订阅流量",
          "derived_access_revoked": "撤销订阅派生权限",
          "derived_grant_created": "创建订阅派生授权"
        },
        "period": {
          "created": "创建计费周期",
          "closed": "结束计费周期"
        },
        "runtime_binding": {
          "pending": "等待运行时绑定"
        },
        "node_group": {
          "rebuild": "重建节点组配置"
        },
        "package_access": {
          "rebuild": "重建套餐权限"
        }
      },
      "subscription": {
        "activated": "激活订阅",
        "disabled": "停用订阅",
        "reset": "重置订阅周期",
        "traffic_reset": "重置订阅流量"
      },
      "subscription_link": {
        "create": "创建订阅链接",
        "patch": "更新订阅链接",
        "delete": "删除订阅链接",
        "rotate_secret": "更换订阅链接密钥",
        "rebind": "订阅链接已重新绑定"
      },
      "user_credential": {
        "create": "创建用户凭证"
      },
      "credential_domain": {
        "create": "创建凭证域"
      },
      "package": {
        "create": "创建套餐",
        "update": "更新套餐",
        "publish": "发布套餐",
        "archive": "归档套餐",
        "delete": "删除套餐"
      },
      "tenant_package": {
        "create": "为租户创建套餐",
        "update": "更新租户套餐",
        "publish": "发布租户套餐",
        "archive": "归档租户套餐",
        "enable": "启用租户套餐",
        "disable": "停用租户套餐",
        "delete": "删除租户套餐"
      },
      "node": {
        "create": "创建服务器节点",
        "update": "更新服务器节点",
        "delete": "删除服务器节点",
        "test": "测试服务器节点"
      },
      "provisioning_bundle": {
        "create": "生成节点部署包",
        "reissue": "重新生成节点部署包"
      },
      "enrollment_token": {
        "generate": "生成注册令牌",
        "consume": "使用注册令牌",
        "action": "变更注册令牌状态"
      },
      "global_node_group": {
        "create": "创建全局节点组",
        "update": "更新全局节点组",
        "delete": "删除全局节点组"
      },
      "global_node_group_member": {
        "add": "添加节点组成员",
        "update": "更新节点组成员",
        "remove": "移除节点组成员"
      },
      "tenant_node_group": {
        "create": "创建租户节点组",
        "delete": "删除租户节点组"
      },
      "node_selection": {
        "replace": "更新节点选择"
      },
      "grant": {
        "create": "创建授权",
        "update": "更新授权",
        "delete": "删除授权"
      },
      "security_deny": {
        "create": "创建拒绝规则",
        "update": "更新拒绝规则",
        "delete": "删除拒绝规则"
      },
      "security": {
        "deny": "拒绝访问"
      },
      "announcement": {
        "create": "创建公告",
        "update": "更新公告",
        "publish": "发布公告",
        "archive": "归档公告",
        "delete": "删除公告"
      },
      "routing_policy": {
        "create": "创建路由策略",
        "update": "更新路由策略",
        "rollback": "回滚路由策略",
        "delete": "删除路由策略"
      },
      "routing_resource": {
        "create": "创建路由资源",
        "update": "更新路由资源",
        "delete": "删除路由资源"
      },
      "manifest": {
        "ack": "确认节点配置",
        "heartbeat": "上报节点心跳"
      },
      "boot_session": {
        "close": "结束启动会话"
      },
      "metering": {
        "sequence_gap": {
          "detected": "检测到流量序列缺口"
        },
        "receipt": {
          "late_covered": "补记延迟流量回执"
        }
      },
      "runtime": {
        "manifest": {
          "build_requested": "请求生成节点配置"
        },
        "subscription": {
          "activate": "下发订阅启用任务",
          "disable": "下发订阅停用任务",
          "prepare_period": "准备订阅周期"
        },
        "user": {
          "disable": "下发用户停用任务"
        }
      },
      "traffic_report": {
        "project_tsdb": "写入流量时序数据"
      },
      "global_routing_policy": {
        "publish": "全局路由已发布"
      }
    },
    "resources": {
      "announcement": "公告",
      "billing_period": "计费周期",
      "boot_session": "启动会话",
      "credential_domain": "凭证域",
      "enrollment_token": "注册令牌",
      "external_subscription": "外部订阅",
      "global_node_group": "全局节点组",
      "global_node_group_member": "节点组成员",
      "global_routing_policy": "全局路由策略",
      "grant": "授权",
      "manifest": "节点配置清单",
      "node": "服务器节点",
      "node_selection": "节点选择",
      "package": "套餐",
      "provisioning_bundle": "部署包",
      "routing_external_resource": "路由资源",
      "security_deny": "拒绝规则",
      "session": "登录会话",
      "subscription": "订阅",
      "subscription_link": "订阅链接",
      "tenant": "租户",
      "tenant_node_group": "租户节点组",
      "traffic_routing_policy": "流量路由策略",
      "unknown": "未知资源",
      "usage_record": "流量记录",
      "user": "用户",
      "user_credential": "用户凭证"
    },
    "actors": {
      "user": "用户",
      "anonymous": "未登录用户",
      "system": "系统",
      "worker": "后台任务",
      "agent": "节点代理",
      "service": "系统服务",
      "operator": "运营人员"
    },
    "outcomes": {
      "success": "成功",
      "failure": "失败",
      "error": "异常",
      "denied": "已拒绝"
    },
    "summaries": {
      "login": "{{email}} 登录了系统",
      "sessionRefreshed": "登录状态已自动续期",
      "logout": "用户已退出登录",
      "externalSync": "导入 {{imported}} 个节点，跳过 {{skipped}} 个 · {{format}} 格式",
      "externalSyncFailure": "同步失败：{{reason}}",
      "managerAssigned": "{{user}} 的负责人已设为 {{manager}}",
      "managerCleared": "已移除 {{user}} 的负责人",
      "failure": "失败原因：{{reason}}",
      "entityCreated": "已创建 {{entity}}",
      "entityDeleted": "已删除 {{entity}}",
      "changedFields": "变更了：{{fields}}",
      "revision": "版本更新至 {{revision}}",
      "target": "对象：{{entity}}"
    },
    "fields": {
      "id": "ID",
      "tenant_id": "租户 ID",
      "user_id": "用户 ID",
      "node_id": "节点 ID",
      "email": "邮箱",
      "display_name": "显示名称",
      "name": "名称",
      "title": "标题",
      "status": "状态",
      "roles": "角色",
      "managed_by": "负责人",
      "manager_user_id": "负责人 ID",
      "format": "格式",
      "revision": "版本",
      "reason": "原因",
      "imported": "导入节点数",
      "skipped": "跳过节点数",
      "detected_format": "识别格式",
      "session_id": "原会话 ID",
      "rotated_session_id": "新会话 ID",
      "created_at": "创建时间",
      "updated_at": "更新时间",
      "token_version": "登录版本",
      "scope": "范围",
      "generation": "配置代次"
    },
    "values": {
      "yes": "是",
      "no": "否",
      "none": "无",
      "unknown": "未知",
      "active": "启用",
      "disabled": "停用",
      "success": "成功",
      "failure": "失败",
      "tenant_admin": "租户管理员",
      "super_admin": "超级管理员",
      "user": "普通用户",
      "uri": "URI",
      "base64": "Base64",
      "fetch_failed": "获取订阅失败",
      "invalid_source": "来源被拒绝（内容无效或内网地址）",
      "internal": "系统内部错误"
    },
    "listSeparator": "、"
  }
}
